module.exports = __webpack_public_path__ + "static/media/gold-era-white.9e3022ae.png";